import React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseDropdown, type BaseDropdownOption } from './BaseDropdown';

export type PostFormat = 'all' | 'regular' | 'reel';

interface PostFormatOption extends BaseDropdownOption {
  id: PostFormat;
}

interface PostFormatDropdownProps {
  value: PostFormat;
  onChange: (format: PostFormat) => void;
  className?: string;
}

export const PostFormatDropdown: React.FC<PostFormatDropdownProps> = ({
  value,
  onChange,
  className = ''
}) => {
  const { t } = useTranslation();

  const postFormats: PostFormatOption[] = [
    { 
      id: 'all', 
      label: t('postFormatDropdown.all', 'All Formats'), 
      emoji: '📋', // Changed from 🌐 to something more relevant to post formats
      description: t('postFormatDropdown.allDesc', 'Show posts in all formats (regular and reel).')
    },
    { 
      id: 'regular', 
      label: t('postFormatDropdown.regular', 'Regular Post'), 
      emoji: '📸', 
      description: t('postFormatDropdown.regularDesc', 'Standard horizontal format posts for feeds.')
    },
    { 
      id: 'reel', 
      label: t('postFormatDropdown.reel', 'Reel/Short'), 
      emoji: '📱', 
      description: t('postFormatDropdown.reelDesc', 'Vertical format content for reels and shorts.')
    }
    // Note: Story format is intentionally omitted as per user request
  ];

  return (
    <BaseDropdown
      value={value}
      onChange={(newValue) => onChange(newValue as PostFormat)}
      options={postFormats}
      className={className}
    />
  );
}; 